/**
 * Returns undefined when the pattern compiles as a RegExp, otherwise a short
 * human-readable error. The empty string is valid here — emptiness is handled
 * by separate required-field checks.
 */
export const getRegexError = (pattern: string): string | undefined => {
  if (pattern === '') {
    return undefined;
  }
  try {
    new RegExp(pattern);
    return undefined;
  } catch (e) {
    const reason = e instanceof Error ? e.message : String(e);
    return `Invalid regex: ${reason}`;
  }
};
